app.directive('compileHtml', ['$compile', '$sce', function ($compile, $sce) {
    return function (scope, element, attrs) {
        scope.$watch(
            function (scope) {
                return scope.$eval(attrs.compileHtml);
            },
            function (value) {
                if (!value) {
                    element.html('');
                    return;
                }

                // 1. If it's an SCE object, get the trusted HTML.
                // 2. If it's a string, use it directly.
                var htmlString = (typeof value === 'object') ? $sce.getTrustedHtml(value) : value;

                // Set the HTML and compile the component
                element.html(htmlString);

                // With `compile-html-only="<selector>"` only the matching elements are compiled, so any
                // {{ }} in the surrounding (user-authored) content is left as text, not evaluated.
                if (attrs.compileHtmlOnly) {
                    angular.forEach(element[0].querySelectorAll(attrs.compileHtmlOnly), function (target) {
                        $compile(target)(scope);
                    });
                    return;
                }

                $compile(element.contents())(scope);
            }
        );
    };
}]);